import { Component, effect, inject, input, type OnInit } from '@angular/core';
import {
  loadPreviousQuestion,
  openInfoModal,
  parsedHomebatteryFunnelToolTrackingConfig,
  selectHomebatteryQuestionnaireCurrentQuestion,
  selectHomebatteryQuestionnaireHasPreviousQuestion,
  submitQuestionnaireAnswer,
} from '@feh/homebattery-store';
import {
  QuestionnaireQuestionSingleComponent,
  type QuestionnaireInfoModalTarget,
  type SingleAnswerQuestionOption,
} from '@feh/shared-ui';
import { Store } from '@ngrx/store';
import { TrackToolService } from '@analytics/events';
import { AnalyticsActionTypes } from '@analytics/models';
import * as Sentry from '@sentry/angular';

import { initializeHomeBatteryFunnelComponent } from '../homebattery-wizard-container/homebattery-wizard.container.helpers';
import type { HomebatteryQuestionnaireRendering } from './homebattery-questionnaire.rendering';

@Sentry.TraceClass({ name: 'FEIT-Homebattery-Questionnaire-Container' })
@Component({
  selector: 'wl-homebattery-questionnaire',
  standalone: true,
  templateUrl: './homebattery-questionnaire.component.html',
  imports: [QuestionnaireQuestionSingleComponent],
})
export class HomebatteryQuestionnaireComponent implements OnInit {
  private readonly store = inject(Store);

  readonly rendering = input.required<HomebatteryQuestionnaireRendering>();
  readonly context = input(null);
  readonly questionData = this.store.selectSignal(
    selectHomebatteryQuestionnaireCurrentQuestion
  );
  readonly hasPreviousQuestion = this.store.selectSignal(
    selectHomebatteryQuestionnaireHasPreviousQuestion
  );
  private readonly trackToolService = inject(TrackToolService);
  private readonly trackToolConfig = parsedHomebatteryFunnelToolTrackingConfig;

  constructor() {
    // Fire trackTool event every time questionData changes
    effect(() => {
      this.trackToolService.trackTool({
        type: AnalyticsActionTypes.STEP,
        ...this.trackToolConfig.forStep(this.questionData().trackingStepName),
      });
    });
  }

  ngOnInit(): void {
    this.store.dispatch(
      initializeHomeBatteryFunnelComponent(
        'questionnaire',
        this.rendering().fields.FunnelSettings
      )
    );
  }

  submitAnswer(answer: SingleAnswerQuestionOption) {
    this.store.dispatch(
      submitQuestionnaireAnswer({ question: this.questionData(), answer })
    );
  }

  goToPreviousQuestion() {
    this.store.dispatch(loadPreviousQuestion());
  }

  requestInfo({ funnelKey }: QuestionnaireInfoModalTarget) {
    this.store.dispatch(openInfoModal({ funnelKey }));
  }
}
